import React from "react";
import Typography from "@mui/material/Typography";

interface LabelProps {
  children: React.ReactNode;
  // Static styles
  fontSize?: string | number;
  fontWeight?: string | number;
  color?: string;
  // Dynamic styles
  sx?: object;
  className?: string;
}

const Label: React.FC<LabelProps> = ({
  children,
  fontSize = "inherit",
  fontWeight = "inherit",
  color = "inherit",
  sx = {},
  className = "",
}) => {
  return (
    <Typography
      variant="body1"
      className={className}
      sx={{
        // Static styles
        fontSize,
        fontWeight,
        color,
        // Dynamic styles
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default Label;
